import React, { useState, useEffect, useRef, createRef, useMemo } from 'react'
import Report from 'react-powerbi';
import { Container, Row } from 'reactstrap';
import ReactLoading from "react-loading";
import MediaQuery from 'react-responsive';
import { useHistory } from 'react-router-dom';

import api from '../../services/api'
import { obterNovaAutenticacao, logout, login } from '../../services/auth'
import NavBIMobile from '../../components/NavBIMobile'
import { URL } from '../../constants/index'
import LogoBranco from '../../assets/LogoBranco.png';
import $ from 'jquery';
import './styles.css';

const Dashboard = (props) => {
  const [idReport, setIdReport] = useState("");
  const [embedUrl, setEmbedUrl] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingErro, setLoadingErro] = useState(false);
  const [menu, setMenu] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const history = useHistory();

  const myRef = createRef();
  const userRef = useRef();

  var TimerDashboard;
  var TimerAutenticacao;

  const onEmbedded = (embed) => {
  }

  useEffect(() => {
    getDashboard();
    startTimerAutenticacao();
    startTimerDashboard();

    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      stopTimerDashboard();
      stopTimerAutenticacao();
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    }
  }, []);

  const refreshDashboardSilencioso = () => {
    const urlAPIDashboard = "/api/dashboard/" + props.URLDashboard;
    
    api.get(urlAPIDashboard)
      .then(res => {
        const newAccessToken = res.data.accessToken;
        if ($(".powerbi-frame").length > 0) {
          const report = window.powerbi.get($(".powerbi-frame")[0]);
          if (report) {
            report.setAccessToken(newAccessToken)
              .then(() => report.refresh())
              .catch(err => console.error("Falha ao atualizar dados ou token silenciosamente", err));
          }
        }
      })
      .catch(err => {
        console.error("Erro ao buscar novos dados do dashboard", err);
      });
  }

  const startTimerDashboard = () => {
    // Atualiza silenciosamente a cada 50 minutos (3000000 ms) para renovar o token e dados antes de expirar
    TimerDashboard = setInterval(() => { refreshDashboardSilencioso(); }, 3000000);
  }

  const stopTimerDashboard = () => {
    clearInterval(TimerDashboard);
  }

  const startTimerAutenticacao = () => {
    TimerAutenticacao = setInterval(() => { getNovaAutenticacao() }, 120000);
  }

  const stopTimerAutenticacao = () => {
    clearInterval(TimerAutenticacao);
  }

  const getNovaAutenticacao = () => {
    const response = obterNovaAutenticacao();

    response.then(res => {
      login(res.data);
    })
    response.catch(err => {
      onLogout();
    })
  }

  const scrollToMyRef = () => {
    // Validar código posteriormente
    if (!myRef) {
      window.scrollTo(0, myRef.current.rootElement.offsetTop)
    }
  }

  const getDashboard = () => {
    setLoading(true);

    const urlAPIDashboard = "/api/dashboard/" + props.URLDashboard;

    api.get(urlAPIDashboard)
      .then(res => {
        setEmbedUrl(res.data.embedURL);
        setIdReport(res.data.reportID);
        setAccessToken(res.data.accessToken);
        setLoading(false);
        setLoadingErro(false);
        setMenu(res.data.listaMenu);
        scrollToMyRef();
      })
      .catch(err => {
        setLoadingErro(true);
        setLoading(false);
      })
  }

  const onLogout = () => {
    logout()
      .then(res => props.history.push(URL.URLLogin))
      .catch(res => props.history.push(URL.URLLogin))
  }

  const desktopReport = useMemo(() => (
    <Report
      ref={myRef}
      id={idReport}
      embedUrl={embedUrl}
      accessToken={accessToken}
      filterPaneEnabled={false}
      mobile={false}
      navContentPaneEnabled={false}
      onEmbedded={onEmbedded}
      embedType='report'
      pageName={props.pageName}
      permissions="Read"
      tokenType="Aad"
      width="100%"
      height="100%"
    />
  ), [idReport, embedUrl, accessToken, props.pageName]);

  if (loading) {
    return (
      <div id="content-bi">
        <div className="dashboard-topbar">
          <div className="topbar-brand">
            <img src={LogoBranco} alt="Logo" className="topbar-logo" />
            <span className="topbar-title">Dashboard - Volpe BI</span>
          </div>
        </div>

        <Container>
          <Row className="justify-content-center">
            <ReactLoading
              type="bubbles"
              color="#343a40"
              height={100}
              width={100}
            />
          </Row>
        </Container>
      </div>
    )
  }

  if (loadingErro) {
    return (
      <div id="content-bi">
        <div className="dashboard-topbar">
          <div className="topbar-brand">
            <img src={LogoBranco} alt="Logo" className="topbar-logo" />
            <span className="topbar-title">Dashboard - Volpe BI</span>
          </div>
        </div>

        <Container>
          <Row className="justify-content-center">
            <h3>Ocorreu um problema ao carregar dashboard</h3>
          </Row>
        </Container>
      </div>
    )
  }

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(err => {
        console.error(`Erro ao ativar tela cheia: ${err.message}`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  const getMenuDashboard = (linkMenu) => {
    if (!linkMenu) return;
    if ($(".powerbi-frame").length === 0) return;
    var report = window.powerbi.get($(".powerbi-frame")[0]);
    report.setPage(linkMenu).catch(err => console.log(err));
  };

  return (
    <div id="content-bi" style={{ position: 'relative' }}>
      {isFullscreen && (
        <button
          onClick={toggleFullscreen}
          title="Sair da Tela Cheia (ESC)"
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            zIndex: 9999,
            background: 'rgba(0, 0, 0, 0.5)',
            border: 'none',
            color: 'white',
            padding: '10px',
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(4px)',
            opacity: 0.3,
            transition: 'opacity 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '0.3'}
        >
          <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path></svg>
        </button>
      )}

      <MediaQuery minDeviceWidth={1224}>
        <div className="dashboard-topbar" style={{ display: isFullscreen ? 'none' : 'flex' }}>
          <div className="topbar-brand">
            <img src={LogoBranco} alt="Logo" className="topbar-logo" />
            <span className="topbar-title">Dashboard - Volpe BI</span>
          </div>

          <div className="topbar-center">
            <select
              className="modern-select"
              onChange={(e) => getMenuDashboard(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>Selecione um Dashboard...</option>
              {menu && menu.map((m, i) => (
                <option key={i} value={m.link}>{m.menu}</option>
              ))}
            </select>
          </div>

          <div className="topbar-actions">
            <button className="btn-topbar-logout" onClick={toggleFullscreen} style={{ marginRight: '12px' }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg>
              Tela Cheia
            </button>
            <button className="btn-topbar-logout" onClick={onLogout} title="Sair do Sistema">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
              Sair
            </button>
          </div>
        </div>
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
            {desktopReport}
          </div>
        </div>
      </MediaQuery>

      <MediaQuery maxDeviceWidth={1224}>
        <NavBIMobile
          menu={menu}
          history={history}
        />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
          <Report
            ref={myRef}
            id={idReport}
            embedUrl={embedUrl}
            accessToken={accessToken}
            filterPaneEnabled={false}
            mobile={true}
            navContentPaneEnabled={false}
            onEmbedded={onEmbedded}
            embedType='report'
            pageName={props.pageNameMobile}
            permissions="Read"
            tokenType="Aad"
            width="100%"
            height="100%"
          />
        </div>
      </MediaQuery>
    </div>
  )
}

export default Dashboard;
